<div class="situation-widget">
    <div #header class="widget-header">
        <p class="title">Situational Reports</p>
    </div>

    <div #content class="widget-content">
        <div *ngFor="let file of showingFiles" class="file clickable" (click)="downloadFile(file)">
            <p class="ellipsis" matTooltip="{{ file.displayName }}">{{ file.displayName }}</p>
            <fa-icon class="icon" icon="file-export"></fa-icon>
        </div>
    </div>

    <div #footer class="widget-footer">
        <mat-paginator hidePageSize showFirstLastButtons (page)="pageFiles($event)"></mat-paginator>
    </div>
</div>
